import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { mediaTiny } from '@xing-com/layout-tokens';
import { SkeletonBodyCopy } from '@xing-com/skeleton';

export const StyledCardInspireChildrenContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: space-between;

  & > p {
    margin-bottom: 0px;
  }

  @media ${mediaTiny} {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
`;
export const StyledSkeletonBodyCopy = styled(SkeletonBodyCopy)`
  width: 100%;
`;
export const StyledViewJobsButton = styled(Button)`
  min-width: 130px;
`;
